import { Box } from 'uiKit/atoms/Box/Box';
import cn from 'classnames';
import styles from '../Modal/Modal.module.scss';

type ContentProps = {
  className?: string;
  children: React.ReactNode;
};

export const Content = ({ className, children }: ContentProps) => {
  return <Box className={cn(styles.modal__content, className)}>{children}</Box>;
};
